export const JoinEfbLandingLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="225"
      height="211"
      viewBox="0 0 225 211"
      fill="none"
      className="absolute bottom-0 end-0 hidden md:flex"
    >
      <g opacity="0.3" clipPath="url(#clip0_8158_22469)">
        <path
          d="M165.622 144.472L148.918 148.289L170.712 243.846L187.416 240.029L165.622 144.472Z"
          fill="#CCC2BF"
        />
        <path
          d="M162.275 105.42L154.842 120.872L243.067 163.393L250.5 147.941L162.275 105.42Z"
          fill="#CCC2BF"
        />
        <path
          d="M217.924 41.1895L129.698 83.7099L137.131 99.162L225.356 56.6415L217.924 41.1895Z"
          fill="#CCC2BF"
        />
        <path
          d="M30.8318 44.9651L17.4363 55.6575L78.486 132.29L91.8815 121.598L30.8318 44.9651Z"
          fill="#CCC2BF"
        />
        <path d="M98.4191 148.859H0.5V166.009H98.4191V148.859Z" fill="#CCC2BF" />
        <path
          d="M123.804 160.757L62.7546 237.39L76.1501 248.083L137.2 171.45L123.804 160.757Z"
          fill="#CCC2BF"
        />
        <path
          d="M114.206 0.0830078L92.4121 95.6394L109.115 99.4565L130.909 3.90005L114.206 0.0830078Z"
          fill="#D5F477"
        />
      </g>
      <defs>
        <clipPath id="clip0_8158_22469">
          <rect width="250" height="248" fill="white" transform="translate(0.5 0.0830078)" />
        </clipPath>
      </defs>
    </svg>
  );
};
